import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/gopath/src/github.com/rumblefrog/source-chat-relay/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "setup"
    }}>{`Setup`}</h1>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <p>{`Make sure you have the following before proceeding with the installation`}</p>
    <ul>
      <li parentName="ul">{`A server to host the relay medium on (MySQL required)`}</li>
      <li parentName="ul">{`Source game server with the `}<a parentName="li" {...{
          "href": "https://forums.alliedmods.net/showthread.php?t=67640"
        }}>{`socket`}</a>{` extension`}</li>
      <li parentName="ul">{`A Discord bot token (`}<a parentName="li" {...{
          "href": "https://discordapp.com/developers/applications/"
        }}>{`https://discordapp.com/developers/applications/`}</a>{`)`}<blockquote parentName="li">
          <p parentName="blockquote">{`Please note that client ID and bot token is not the same thing`}</p>
        </blockquote></li>
    </ul>
    <h2 {...{
      "id": "download"
    }}>{`Download`}</h2>
    <p>{`Download the latest release from `}<a parentName="p" {...{
        "href": "https://github.com/rumblefrog/source-chat-relay/releases"
      }}>{`releases`}</a>{` for either linux/windows`}</p>
    <blockquote>
      <p parentName="blockquote">{`Note: If you need additional OS/Architectural support, you may build the server binary yourself`}</p>
    </blockquote>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <ul>
      <li parentName="ul">{`Upload the binary file (server`}{`[.exe]`}{`) to the server`}</li>
      <li parentName="ul">{`Upload the plugin to the Sourcemod plugins folder and load the plugin by either restart, change map, and/or via `}<inlineCode parentName="li">{`sm plugins load Source-Chat-Relay`}</inlineCode></li>
    </ul>
    <h2 {...{
      "id": "configuration"
    }}>{`Configuration`}</h2>
    <ul>
      <li parentName="ul">{`Configure the `}<inlineCode parentName="li">{`config.toml.example`}</inlineCode>{` on the relay server and rename it to `}<inlineCode parentName="li">{`config.toml`}</inlineCode></li>
      <li parentName="ul">{`Configure `}<inlineCode parentName="li">{`cfg/sourcemod/Source-Chat-Relay.cfg`}</inlineCode>{` on the game server`}</li>
    </ul>
    <h2 {...{
      "id": "inviting-the-bot"
    }}>{`Inviting the bot`}</h2>
    <p>{`Copy, replace `}<inlineCode parentName="p">{`CLIENT_ID`}</inlineCode>{` with the client ID on your Discord bot application and navigate to it in your browser.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`https://discordapp.com/api/oauth2/authorize?client_id=CLIENT_ID&permissions=8&scope=bot
`}</code></pre>
    <h2 {...{
      "id": "connecting"
    }}>{`Connecting`}</h2>
    <p>{`This is the part that everyone gets confused on, so please follow it carefully.`}</p>
    <h3 {...{
      "id": "how-the-system-works-prelude"
    }}>{`How the system works (Prelude)`}</h3>
    <p>{`Before actually connecting everything, you should familarize yourself with how the system actually works.`}</p>
    <p>{`The concept is similar to TV `}<strong parentName="p">{`channels`}</strong>{`, you can broadcast on a channel and you can view/receive on a channel, with the only difference is that you can may view/receive on multiple channels at once.`}</p>
    <p>{`Entities are bidirectional (both direction send/receive), meaning they are both capable of broadcasting and view/receiving.`}</p>
    <h3 {...{
      "id": "connecting-1"
    }}>{`Connecting`}</h3>
    <p>{`If all goes well and the game server successfully connects to the relay server, you should see an entity from each game server when you run `}<inlineCode parentName="p">{`r/entities`}</inlineCode>{` as a command to the Discord bot (If you don't, see `}<a parentName="p" {...{
        "href": "https://rumblefrog.me/source-chat-relay/troubleshooting"
      }}>{`Troubleshooting`}</a></p>
    <p>{`You may now began linking things, copy the entity ID of the game server and use `}<inlineCode parentName="p">{`r/receivechannel`}</inlineCode>{` and `}<inlineCode parentName="p">{`r/sendchannel`}</inlineCode>{` to configure the receive and send properties`}</p>
    <blockquote>
      <p parentName="blockquote">{`Note that you cannot use these commands within private message, it must be used within a server
Note that you need to have `}<inlineCode parentName="p">{`Link Preview`}</inlineCode>{` enabled within your Discord to view the command outputs correctly`}</p>
    </blockquote>
    <p>{`Examples:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`r/receivechannel !@#$%^klmwxyz01bc2345nopqr 1`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`r/sendchannel !@#$%^klmwxyz01bc2345nopqr 1`}</inlineCode></li>
    </ul>
    <p>{`Similarily, you can do the same for Discord text channel`}</p>
    <p>{`Examples:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`r/receivechannel #general 1`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`r/sendchannel #general 1`}</inlineCode></li>
    </ul>
    <p>{`Just like, two entities are configured to both send and receive on channel `}<inlineCode parentName="p">{`1`}</inlineCode></p>
    <p>{`More in depth explanation of the commands is available at `}<a parentName="p" {...{
        "href": "bot-commands.md"
      }}>{`Bot Commands`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      